export const views = {
    day: true,
}
